export default "__VITE_ASSET__DH$M0UpR__"